import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className="kuika_rotate90deg"
      style={{ marginTop: "-3px" }}
      {...props}
    >
      <defs>
        <filter id="hb8772lrva">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.286275 0 0 0 0 0.341176 0 0 0 0 0.400000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g filter="url(#hb8772lrva)" transform="translate(-1360 -444) translate(1151 48)">
            <g>
              <path d="M0 0H16V16H0z" transform="rotate(-90 310.5 101.5)" />
              <path
                fill="#A5A5A5"
                fillRule="nonzero"
                d="M8.87 8L6.216 5.286c-.288-.294-.288-.771 0-1.065.287-.295.754-.295 1.042 0l3.205 3.277c.272.278.272.727 0 1.004L7.258 11.78c-.288.295-.755.295-1.042 0-.288-.294-.288-.77 0-1.065L8.87 8z"
                transform="rotate(-90 310.5 101.5) rotate(90 8.333 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
